//
//
//
//
//
//
//
//
//
//
//
//
//
//

import debounce from 'lodash/debounce'
import { createNamespacedHelpers } from 'vuex'
import wcs from '@/scripts/libs/wcs'
import { MOBILE, TABLET } from '@/scripts/constants/media-query'
import { EVENTS } from '@/scripts/constants/css-classes'
const { mapGetters: mapGettersVirtualMirror } = createNamespacedHelpers('virtualMirror')
const RbRoxPanel = () => import('@/elements/rox-panel/rb-rox-panel.vue')

export default {
  name: 'rb-virtual-mirror',
  components: {
    RbRoxPanel,
  },
  data() {
    return {
      windowInnerHeight: window.innerHeight,
    }
  },
  computed: {
    ...mapGettersVirtualMirror(['isVisible']),
    isRoxPanelEnabled() {
      const { roxLensPanel } = wcs.getStoreConfig()
      return roxLensPanel.isEnabled
    },
    isInCartOrPdp() {
      return wcs.isInCart() || wcs.isInPdp()
    },
    roxPanelIsVisible() {
      return this.isRoxPanelEnabled && this.isVisible && !this.isInCartOrPdp
    },
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },
  },
  watch: {
    windowInnerHeight() {
      this.updateVhMainCssVariable()
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener(EVENTS.RESIZE, debounce(this.updateWindowInnerHeight, 30))
    })
  },
  beforeDestroy() {
    window.removeEventListener(EVENTS.RESIZE, debounce(this.updateWindowInnerHeight, 30))
  },
  methods: {
    updateVhMainCssVariable() {
      const vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vhmain', `${vh}px`)
    },
    updateWindowInnerHeight() {
      if (this.isVisible) {
        this.windowInnerHeight = window.innerHeight
      }
    },
  },
}
